import { createRouter, createWebHistory } from 'vue-router';

import { useAuthStore } from '../stores/auth';

/**
 * Les écrans, dans l'ordre du parcours réel : on accueille, on trie, on lit le
 * résultat, on installe, puis on consulte. Les tableaux de bord viennent après,
 * et les écrans d'affichage vivent à part — ce sont des comptes qui n'ont accès
 * à rien d'autre.
 */
export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/connexion',
      name: 'connexion',
      component: () => import('../views/ConnexionView.vue'),
      meta: { public: true, chrome: false },
    },
    {
      path: '/',
      name: 'accueil',
      component: () => import('../views/AccueilView.vue'),
    },
    {
      path: '/tri/:visitId?',
      name: 'tri',
      component: () => import('../views/TriView.vue'),
    },
    {
      path: '/passage/:visitId',
      name: 'passage',
      component: () => import('../views/ResultatView.vue'),
    },
    {
      path: '/salles',
      name: 'salles',
      component: () => import('../views/SallesView.vue'),
    },
    {
      path: '/registre',
      name: 'registre',
      component: () => import('../views/RegistreView.vue'),
    },
    {
      path: '/ecran/soignants',
      name: 'ecran-soignants',
      component: () => import('../views/EcranSoignantsView.vue'),
      meta: { chrome: false, fullscreen: true },
    },
    {
      path: '/ecran/attente',
      name: 'ecran-attente',
      component: () => import('../views/EcranAttenteView.vue'),
      meta: { chrome: false, fullscreen: true },
    },
    {
      path: '/administration',
      name: 'administration',
      component: () => import('../views/AdminHopitalView.vue'),
    },
    {
      path: '/administration/plateforme',
      name: 'administration-plateforme',
      component: () => import('../views/AdminGlobalView.vue'),
      meta: { globalAdmin: true },
    },
    {
      path: '/administration/arbre',
      name: 'administration-arbre',
      component: () => import('../views/ArbreEditeurView.vue'),
      meta: { globalAdmin: true, chrome: false },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'accueil' },
    },
  ],
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();

  // Au premier chargement, le cookie permet peut-être de reprendre la session
  // sans redemander le mot de passe.
  if (!auth.ready) await auth.restore();

  if (to.meta['public'] === true) {
    return auth.isAuthenticated && to.name === 'connexion' ? { name: 'accueil' } : true;
  }

  if (!auth.isAuthenticated) {
    return { name: 'connexion', query: { suite: to.fullPath } };
  }

  // Un compte « écran » n'a rien à faire ailleurs que sur son écran : il est
  // souvent affiché dans un couloir, sans surveillance.
  if (auth.isDisplayAccount) {
    const target =
      auth.displayMode === 'SOIGNANTS' ? 'ecran-soignants' : 'ecran-attente';
    return to.name === target ? true : { name: target };
  }

  if (to.meta['globalAdmin'] === true && auth.user?.isGlobalAdmin !== true) {
    return { name: 'accueil' };
  }

  return true;
});
